import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Apple, Play, Smartphone } from 'lucide-react';
import { APP_SCHEME_AUTH, APP_STORE_URL, PLAY_STORE_URL, detectPlatform, storeUrlFor } from '../lib/appLinks';

export default function AppAuth() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const [platform] = useState(detectPlatform);
  const appUrl = code ? `${APP_SCHEME_AUTH}?code=${encodeURIComponent(code)}` : APP_SCHEME_AUTH;

  useEffect(() => {
    if (platform === 'desktop') return undefined;
    window.location.href = appUrl;
    const t = setTimeout(() => {
      if (!document.hidden) window.location.href = storeUrlFor(platform);
    }, 1800);
    return () => clearTimeout(t);
  }, [platform, appUrl]);

  return (
    <div data-testid="app-auth-page" className="min-h-[70vh] bg-brand-cream flex items-center justify-center px-5 py-20">
      <div className="max-w-md w-full bg-white rounded-3xl border border-brand-cream-dark p-10 text-center shadow-sm">
        <div className="w-14 h-14 rounded-2xl bg-brand-green mx-auto flex items-center justify-center mb-6">
          <Smartphone className="w-6 h-6 text-brand-cream" />
        </div>
        <h1 className="font-serif text-3xl text-brand-green">Opening LISTING AiGENT…</h1>
        <p data-testid="app-auth-status" className="mt-3 text-brand-green/70">
          {platform === 'desktop'
            ? 'Open this link on your phone to sign in to the app automatically.'
            : "If the app doesn't open, install it below — then tap Open app again."}
        </p>
        <div className="mt-8 flex flex-col gap-3">
          {platform !== 'desktop' && (
            <a data-testid="app-auth-open-app-btn" href={appUrl} className="px-6 py-3 rounded-lg bg-brand-green text-brand-cream font-semibold hover:bg-brand-green-dark transition-colors">
              Open app
            </a>
          )}
          <a data-testid="app-auth-appstore-link" href={APP_STORE_URL} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-brand-green text-brand-green hover:bg-brand-cream transition-colors">
            <Apple className="w-4 h-4" /> App Store
          </a>
          <a data-testid="app-auth-playstore-link" href={PLAY_STORE_URL} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-brand-green text-brand-green hover:bg-brand-cream transition-colors">
            <Play className="w-4 h-4" /> Google Play
          </a>
        </div>
      </div>
    </div>
  );
}
